import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import common from './modules/common';
import landings from './modules/landings';

export default function createReducer() {
  return combineReducers({
    form: formReducer,
    common,
    landings,
  });
}
